import s from "./style.module.scss";
import { logoList } from "./data";
import { useSectionsData } from "../../utils/useSectionsData.ts";

interface LogoImage {
  logo_img: string;
}

export const ReferencesLogos = () => {
  const sections = useSectionsData();
  const scientificallyBackedSection = sections?.pp_v7_scientifically_backed;
  const generalSettings = window?.general_settings;
  const logoImages: LogoImage[] =
    scientificallyBackedSection?.references_logos?.length > 0
      ? scientificallyBackedSection.references_logos
      : logoList.map((item) => ({ logo_img: item.url }));

  return (
    <div className={s.referencesLogos}>
      <>
        {logoImages.map((logo, index) => (
          <div key={index} className={s.hideOnMobile}>
            <img src={logo.logo_img} alt={generalSettings.brand_name} />
          </div>
        ))}
        <img
          src={`${window.template_root}/v1/logo-slider-mobile.jpg`}
          alt={generalSettings.brand_name}
          className={`${s.hideOnTablet} ${s.mobLogoSlider}`}
          height={176}
          width={343}
        />
      </>
    </div>
  );
};
